import React, { useCallback, useMemo } from 'react';
import { useLazyQuery } from '@apollo/client';
import { GenericFilterHeader } from './GenericFilterHeader';
import { GET_ALL_PRODUCT_CATEGORIES } from '../../../../apollo/queries/productCategory';
import { ProductCategory } from '../../../../codegen/graphql';

interface ProductCategoryHeaderProps {
    readonly currentValue: string[] | null;
    readonly onChange: (value: string[] | null) => void;
}

type ProductCategoriesQueryResult = {
    getAllProductCategories: ProductCategory[];
};

export function ProductCategoryHeader({
    currentValue,
    onChange,
}: ProductCategoryHeaderProps) {
    const [fetchCategories, { data: productCategoriesData, loading }] =
        useLazyQuery<ProductCategoriesQueryResult>(GET_ALL_PRODUCT_CATEGORIES, {
            fetchPolicy: 'cache-first',
        });

    const handleOpen = useCallback(() => {
        fetchCategories();
    }, [fetchCategories]);

    const filterOptions = useMemo(() => {
        if (!productCategoriesData) return ['All'];

        const categoryNames = productCategoriesData.getAllProductCategories
            .filter(category => category.name)
            .map(category => category.name!);

        const uniqueCategoryNames = Array.from(new Set(categoryNames));

        return ['All', ...uniqueCategoryNames];
    }, [productCategoriesData]);

    return (
        <GenericFilterHeader
            label="Product Category"
            filterOptions={filterOptions}
            currentValue={currentValue}
            onChange={onChange}
            onOpen={handleOpen}
            loading={loading}
        />
    );
}

ProductCategoryHeader.displayName = 'ProductCategoryHeader';
